import { employeeBussiness } from "api/bussiness/employee/employee-bussiness";
import { populateEnumApiToOptionItem } from "commons/ultilities";
import { OptionItem } from "commons/ultilities/dynamic-form/models/control";

export const searchDepartmentTypeOptions = async (): Promise<OptionItem[]> => {
  const res = await employeeBussiness.getDepartmentTypes();
  return (
    res.items?.map((x) => ({
      value: x.id,
      label: x.name,
    })) || []
  );
};

export const searchGenderOptions = async (): Promise<OptionItem[]> => {
  const res = await employeeBussiness.getGender();
  return populateEnumApiToOptionItem(res);
};

export const searchRecruitmentSourceOptions = async (): Promise<
  OptionItem[]
> => {
  const res = await employeeBussiness.getRecruitmentResource();
  return populateEnumApiToOptionItem(res);
};

export const searchEmploymentStatusOptions = async (): Promise<
  OptionItem[]
> => {
  const res = await employeeBussiness.getEmploymentStatus();
  return populateEnumApiToOptionItem(res);
};

export const searchEmploymentContractTypeOptions = async (): Promise<
  OptionItem[]
> => {
  const res = await employeeBussiness.getEmploymentContractType();
  return populateEnumApiToOptionItem(res);
};

export const searchEmploymentContractTermTypeOptions = async (): Promise<
  OptionItem[]
> => {
  const res = await employeeBussiness.getEmploymentContractTermType();
  return populateEnumApiToOptionItem(res);
};
